import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CircularLoader, Typography } from '@HomaHealth/ui-component-library';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import clsx from 'clsx';

export interface FilterFlowDataProps {
  label: string;
  count: number;
  percent: string;
  type: 'TOTAL' | 'FILTER';
}

interface FilterFlowProps {
  data: FilterFlowDataProps[];
  isLoading: boolean;
}

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  stepWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 26px',
    borderRadius: '8px',
    alignItems: 'center',
    gap: '0.5rem',
  },
  totalCard: {
    width: '300px',
    backgroundColor: patientAccessTheme.palette.primary[400],
  },
  filterCard: {
    background: '#E8EAF6',
    width: '250px',
  },
  connector: {
    width: 2,
    height: 42,
    background: '#D1D5DB',
    margin: theme.spacing(0.5, 0),
  },
  countText: {
    fontWeight: 600,
  },
}));

const FilterFlow = ({ data, isLoading }: FilterFlowProps) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.wrapper}>
      {data.map((item, index) => (
        <Box key={index} className={classes.stepWrapper}>
          <Box
            className={clsx(
              classes.card,
              item.type === 'TOTAL' ? classes.totalCard : classes.filterCard,
            )}
          >
            <Typography
              fontSize="14px"
              lineHeight="24px"
              textColor={
                item.type === 'TOTAL'
                  ? patientAccessTheme.palette.status.white
                  : patientAccessTheme.palette.text.highemphasis
              }
            >
              {item.label}:{' '}
              <span className={classes.countText}>
                {item.count} ({item.percent})
              </span>
            </Typography>
          </Box>
          {index !== data.length - 1 && <Box className={classes.connector} />}
        </Box>
      ))}

      {isLoading && (
        <Box className={classes.stepWrapper}>
          <Box className={classes.connector} />
          <CircularLoader />
        </Box>
      )}
    </Box>
  );
};

export default FilterFlow;
